<template>
  <div class="logo-wrapper align-center d-flex flex-row">
    <header-logo-divider :fields="this.fields" v-if="this.HasDividerBefore == true"></header-logo-divider>
    <div class="header-logo" :class="LogoClass">
      <sc-link
        class="logo-link"
        v-if="this.fields.LinkUrl.value.href || this.isSitecoreExperienceEditorOn"
        :field="this.fields.LinkUrl"
        :editable="false"
      >
        <sc-image
          class="logo"
          :class="LogoClass"
          :media="fields.LogoImage"
          :editable="false"
        />
      </sc-link>
      <sc-image 
        class="logo"     
        v-else-if="!this.fields.LinkUrl.value.href" 
        :class="LogoClass" :media="fields.LogoImage" 
        :editable="false"
      />
    </div>
  </div>
</template>

<script>
import { Image, Link, isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';
import HeaderLogoDivider from './HeaderLogoDivider.vue';
export default {
  name: 'HeaderLogo',
  data() {
    return {};
  },
  props: {
    fields: {
      type: Object,
      default: () => ({
        LogoImage: null,
        LinkUrl: null,
        DivivderBefore: null,
        LogoTheme:null,
      }),
    },
  },
  components: {
    ScImage: Image,
    ScLink: Link,
    HeaderLogoDivider: HeaderLogoDivider
  },
  computed: {
    isInternal() {
      if (this.linkField.value.linktype == 'internal') {
        return true;
      } else {
        return false;
      }
    },
    isSitecoreExperienceEditorOn() {
      // TODO may need to add other check like the preview mode
      return isExperienceEditorActive();
    },
    LogoClass() {
      let className = '';
      if (
        this.fields.LogoTheme &&
        this.fields.LogoTheme.fields &&
        this.fields.LogoTheme.fields.ThemeClass
      ) {
        className = this.fields.LogoTheme.fields.ThemeClass.value;
      }
      return className;
    },
    HasDividerBefore() {
      let result = false;
      if (
        this.fields.DivivderBefore &&
        this.fields.DivivderBefore.value
      ) {
        result = this.fields.DivivderBefore.value;
      }
      return result;
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
